import React from 'react'; 
import Background from '../../../components/patientApp/background/background'
import AppHomeComp from '../../../components/patientApp/Home/home'

const AppHome = () => {
    return <Background>
        <AppHomeComp />
    </Background>
}
export default AppHome;